{
  "cancelOrder": {
    "title": "Отмена ордера",
    "ticker": "Тикер",
    "operation": "Операция",
    "quantity": "Количество",
    "price": "Цена",
    "orderType": "Тип ордера",
    "executed": "Исполнено",
    "orderDuration": "Срок ордера",
    "stopPrice": "Стоп цена",
    "limitPrice": "Лимит цена",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "complexOrders": "Группа ордеров",
    "no": "Нет",
    "yes": "Да",
    "status": {
      "new": "Новый",
      "partially_filled": "Частично",
      "filled": "Исполнен",
      "done_for_day": "Завершен на сегодня",
      "canceled": "Отменен",
      "expired": "Истек",
      "replaced": "Заменен",
      "pending_cancel": "Ожидает отмены",
      "pending_replace": "Ожидает замены",
      "accepted": "В обработке",
      "pending_new": "Ожидает создания",
      "rejected": "Отклонен",
      "calculated": "Вычисляется",
      "accepted_for_bidding": "Принят на торги",
      "stopped": "Остановлен",
      "suspended": "Приостановлен",
      "held": "Ожидает"
    },
    "side": {
      "buy": "Купить",
      "sell": "Продать",
      "sell_short": "Продажа в шорт"
    },
    "types": {
      "market": "Рыночный",
      "limit": "Лимитный",
      "stop": "Стоп",
      "stop_limit": "Стоп-лимитный",
      "trailing_stop": "Трейлинг-стоп"
    },
    "terms": {
      "day": "DAY",
      "gtc": "GTC",
      "opg": "OPG",
      "cls": "CLS",
      "ioc": "IOC",
      "dayPlus": "DAY+"
    },
    "attributes": {
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit"
    }
  }
}
